import { create } from 'zustand';

/**
 * Store global del toast de feedback (éxito/error). Vive fuera del árbol de
 * componentes para sobrevivir a la navegación entre páginas: si el estado
 * fuera local a la página (useState), un navigate() inmediato la desmonta
 * junto con el toast antes de que el usuario lo llegue a ver.
 */
export const useToastStore = create((set) => ({
  toast: null,
  showToast: (description, variant = 'success') =>
    set({ toast: { description, variant, key: Date.now() } }),
  hideToast: () => set({ toast: null }),
}));
